export default __webpack_public_path__ + "vision-examples-basic-ar-navigation-thumbnail-480-4da144cc49bd608762bb771ebdda48eb.png";